import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getReferralSiteTimezoneAPI(id: string) {
  return serviceRequest(() => Service.referralControllerGetSiteTimeZoneCurrentUser(id));
}
